import { Button, Typography } from '@breetometer/components';
import { closeModal, selectModals, selectSellAssets, useAppDispatch, useAppSelector } from 'BreetRedux';
import { type ChangeEvent, useCallback, useState } from 'react';
import { useNavigate } from 'react-router';

import ImageComponent from '../ImageComponent';
import SearchInput from '../SearchInput';
import { filterBySearch, filterBySymbol } from './DialogAssetGroup.helpers';

const DialogAssetGroup = () => {
	const navigate = useNavigate();

	const [searchValue, setSearchValue] = useState<string>('');

	const modalProps = useAppSelector(selectModals);

	const dispatch = useAppDispatch();

	const selectedModalProps = modalProps.find((i) => i.id === 'assetGroup');

	const selectedAssetSymbol = selectedModalProps?.metadata as { symbol: string } | undefined;

	const { data: tradeSellAssetsData } = useAppSelector(selectSellAssets);

	const tradeSellAssets = tradeSellAssetsData?.data ?? [];

	const handleAssetClick = useCallback(
		(symbol: string, id: string) => () => {
			navigate(`/assets/${symbol}`, { state: { id } })
				?.then(() => dispatch(closeModal('assetGroup')))
				.catch(console.error);
		},
		[dispatch, navigate]
	);

	const onHandleSearch = useCallback((e: ChangeEvent<HTMLInputElement>) => {
		setSearchValue(e.target.value);
	}, []);

	const filteredTradeSellAssets = tradeSellAssets
		.filter(filterBySymbol(selectedAssetSymbol?.symbol))
		.filter(filterBySearch(searchValue));

	const isSearchEnabled = filteredTradeSellAssets.length > 10;
	const noAssetsFound = filteredTradeSellAssets.length === 0;

	return (
		<div className='asset-group bg-primary-500'>
			<div className='asset-group_header'>
				<Typography
					as='h3'
					className='color-neutral-50'
				>
					Select Asset
				</Typography>
			</div>

			{isSearchEnabled && (
				<div className='asset-group_search'>
					<SearchInput
						widthType='full'
						placeholder='Search'
						value={searchValue}
						onChange={onHandleSearch}
					/>
				</div>
			)}

			{noAssetsFound && <Typography className='color-primary-100'>No assets found</Typography>}

			<ul className='asset-group_assets scrollbar'>
				{filteredTradeSellAssets.map((tradeSellAssetItem) => (
					<li key={tradeSellAssetItem._id}>
						<Button
							variant='native'
							onClick={handleAssetClick(tradeSellAssetItem.symbol, tradeSellAssetItem._id)}
							trailingIcon={<ImageComponent src={tradeSellAssetItem.avatar as unknown as string} />}
							className='color-primary-50 bg-primary-400-hover color-tertiary-400-hover'
						>
							{tradeSellAssetItem.name}
						</Button>
					</li>
				))}
			</ul>
		</div>
	);
};

export default DialogAssetGroup;
